/**
 * Vessel Cart Progress Bar
 * Tracks NinjaFlex product (ALL variants combined) and shows discount progress
 */

class VesselCartProgress {
  constructor() {
    // Your NinjaFlex product ID - tracks ALL color variants
    this.TRACKED_PRODUCT_ID = '8832896639262';
    
    this.tiers = [
      { qty: 1, discount: 0, price: 130, label: '1 Roll', position: 12.5 },
      { qty: 2, discount: 10, price: 117, label: '10% off', position: 25 },
      { qty: 3, discount: 15, price: 110.50, label: '15% off', position: 37.5 },
      { qty: 5, discount: 20, price: 104, label: '20% off', position: 100 }
    ];
    
    this.wasUnlocked = false;
    this.init();
  }

  init() {
    this.progressBar = document.getElementById('cart-progress-bar');
    
    if (!this.progressBar) {
      console.log('Cart progress bar not found - waiting for cart drawer to load');
      return;
    }

    this.progressMessage = this.progressBar.querySelector('[data-progress-message]');
    this.progressTotal = this.progressBar.querySelector('[data-progress-total]');
    this.progressFill = this.progressBar.querySelector('[data-progress-fill]');
    this.milestonesContainer = this.progressBar.querySelector('[data-milestones]');
    this.tierElements = this.progressBar.querySelectorAll('.progress-tier');

    // Listen to all possible cart update events
    document.addEventListener('cart:updated', () => this.updateProgress());
    document.addEventListener('theme:cart:change', () => this.updateProgress());
    document.addEventListener('cart:refresh', () => this.updateProgress());
    
    // Poll cart as backup every 2 seconds
    this.pollInterval = setInterval(() => this.updateProgress(), 2000);
    
    // Initial update
    this.updateProgress();
    
    console.log('Cart progress bar initialized for product ID:', this.TRACKED_PRODUCT_ID);
  }

  async updateProgress() {
    const quantity = await this.getTrackedProductQuantity();
    this.renderProgress(quantity);
  }

  async getTrackedProductQuantity() {
    try {
      const response = await fetch('/cart.js');
      const cart = await response.json();
      
      // Count ALL variants of the NinjaFlex product (all colors combined)
      const trackedItems = cart.items.filter(item => 
        item.product_id.toString() === this.TRACKED_PRODUCT_ID
      );
      
      const totalQuantity = trackedItems.reduce((total, item) => total + item.quantity, 0);
      
      return totalQuantity;
    } catch (error) {
      console.error('Error fetching cart:', error);
      return 0;
    }
  }

  calculateProgress(quantity) {
    if (quantity === 0) return 0;
    if (quantity >= 5) return 100;
    if (quantity === 4) return 62.5;
    if (quantity === 3) return 37.5;
    if (quantity === 2) return 25;
    if (quantity === 1) return 12.5;
    return 0;
  }

  getCurrentTier(quantity) {
    let currentTier = this.tiers[0];
    for (let tier of this.tiers) {
      if (quantity >= tier.qty) currentTier = tier;
    }
    return currentTier;
  }

  renderProgress(quantity) {
    // Show/hide progress bar based on quantity
    if (quantity > 0) {
      this.progressBar.style.display = 'block';
    } else {
      this.progressBar.style.display = 'none';
      return;
    }

    const currentTier = this.getCurrentTier(quantity);
    const nextTier = this.tiers.find(t => t.qty > quantity);
    const progress = this.calculateProgress(quantity);
    const isMaxUnlocked = quantity >= 5;

    // Celebration effect when max discount unlocked
    if (isMaxUnlocked && !this.wasUnlocked) {
      this.progressBar.classList.add('unlocked');
      this.wasUnlocked = true;
    } else if (!isMaxUnlocked) {
      this.progressBar.classList.remove('unlocked');
      this.wasUnlocked = false;
    }

    // Update progress bar fill
    this.progressFill.style.width = progress + '%';

    // Update milestone markers
    const milestones = this.milestonesContainer.querySelectorAll('.progress-milestone');
    milestones.forEach(milestone => {
      const milestoneQty = parseInt(milestone.dataset.qty);
      milestone.classList.toggle('reached', quantity >= milestoneQty);
    });

    // Update tier cards
    this.tierElements.forEach((el, index) => {
      el.classList.toggle('active', quantity >= this.tiers[index].qty);
    });

    // Update message text
    if (quantity === 0) {
      this.progressMessage.textContent = 'Add items to unlock discounts!';
    } else if (nextTier) {
      const remaining = nextTier.qty - quantity;
      this.progressMessage.textContent = `Add ${remaining} more roll${remaining > 1 ? 's' : ''} for ${nextTier.label}!`;
    } else {
      this.progressMessage.innerHTML = '<strong>🎉 MAX DISCOUNT UNLOCKED!</strong> You\'re saving 20%';
    }

    // Update total price with savings
    if (quantity > 0) {
      const total = (quantity * currentTier.price).toFixed(2);
      const regularPrice = (quantity * 130).toFixed(2);
      const savings = (regularPrice - total).toFixed(2);
      
      if (savings > 0) {
        this.progressTotal.innerHTML = `Total: <strong>$${total}</strong> <span class="savings">(Save $${savings}!)</span>`;
      } else {
        this.progressTotal.innerHTML = `Total: <strong>$${total}</strong>`;
      }
    } else {
      this.progressTotal.textContent = '';
    }
  }

  destroy() {
    if (this.pollInterval) {
      clearInterval(this.pollInterval);
    }
  }
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    window.vesselCartProgress = new VesselCartProgress();
  });
} else {
  window.vesselCartProgress = new VesselCartProgress();
}

// Also try to initialize when cart drawer opens
document.addEventListener('cart:updated', () => {
  if (!window.vesselCartProgress && document.getElementById('cart-progress-bar')) {
    window.vesselCartProgress = new VesselCartProgress();
  }
});